import { render } from "./EquiposComunicacionSection.vue?vue&type=template&id=2c8c6766&ts=true"
import script from "./EquiposComunicacionSection.vue?vue&type=script&lang=ts"
export * from "./EquiposComunicacionSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__